import React from "react";

function Home() {
	return <div>Admin Home</div>;
}

export default Home;
